import React, { FC } from 'react'

import { FormattedMessage } from 'react-intl'

import { useIsCurrentUser } from 'hooks/useIsCurrentUser'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

import { pageServiceAlbums } from '../constants'

export const NameService: FC<{
  serviceName?: string
  withoutServiceName?: boolean
}> = ({ serviceName, withoutServiceName }) => {
  const { totalPhotos, id } = useShallowEqualSelector(
    ({ photoAlbumReducer: { totalPhotos, id } }) => ({
      totalPhotos,
      id,
    })
  )

  const isCurrentUser = useIsCurrentUser(String(id))

  if (withoutServiceName || !id) {
    return null
  }

  switch (serviceName) {
    case pageServiceAlbums:
      if (isCurrentUser) {
        return (
          <FormattedMessage
            id="service.albums.current.user.title"
            defaultMessage="Мои фото ({totalPhotos})"
            values={{ totalPhotos }}
          />
        )
      }

      return (
        <FormattedMessage
          id="service.albums.title"
          defaultMessage="Фото ({totalPhotos})"
          values={{ totalPhotos }}
        />
      )

    default:
      return null
  }
}
